import React from 'react';
import { Skeleton } from 'antd';
import { VideoCameraOutlined } from '@ant-design/icons';

interface MediaPlaceholderProps {
  isVideo?: boolean;
}

const MediaPlaceholder: React.FC<MediaPlaceholderProps> = ({ isVideo = false }) => {
  if (isVideo) {
    return (
      <div className="flex h-full w-full items-center justify-center bg-gray-100">
        <div className="relative h-full w-full">
          <Skeleton.Node
            active
            className="!h-full !w-full [&_.ant-skeleton-image]:!h-full [&_.ant-skeleton-image]:!w-full [&_.ant-skeleton-node]:!h-full [&_.ant-skeleton-node]:!w-full">
            <VideoCameraOutlined className="text-gray-400" style={{ fontSize: '52px' }} />
          </Skeleton.Node>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full items-center justify-center bg-gray-100">
      <Skeleton.Image active className="!h-full !w-full [&_.ant-skeleton-image]:!h-full [&_.ant-skeleton-image]:!w-full" />
    </div>
  );
};

export default MediaPlaceholder;
